import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import * as myConstants from '../../../contexts/My/myConstants';

import RootRoutes from '../../../roots/RootRoutes';

const MyAccountPage = lazy(() => import('./MyAccountPage'));
const MyContentAddEntityPage = lazy(() => import('./MyContentAddEntityPage'));
const MyContentsPage = lazy(() => import('./MyContentsPage'));
const MyOrdersPage = lazy(() => import('./MyOrdersPage'));


function Index() {


    return (
        <RootRoutes>

            {/* Redirect to default buy page as long as my dashboard is no available */}
            <Route
                element={'Dashboard'}
                exact={true}
                path={'/'}
            />

            <Route
                element={<MyAccountPage/>}
                path={myConstants.NAV_MY_ACCOUNT}
            />

            <Route
                element={<MyContentsPage/>}
                path={myConstants.NAV_MY_CONTENT}
            />

            <Route
                element={<MyContentAddEntityPage/>}
                path={myConstants.NAV_MY_CONTENT_ADD_ENTITY}
            />

            <Route
                element={<MyOrdersPage/>}
                path={myConstants.NAV_MY_ORDERS}
            />

        </RootRoutes>
    );
}


export default Index;
